// Additional polyfills
import 'custom-event-polyfill'
import 'url-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/permission'
import { BootstrapVue, ToastPlugin } from 'bootstrap-vue'
import flatpickr from 'flatpickr'
import { Turkish } from 'flatpickr/dist/l10n/tr.js'
import VueClipboard from 'vue-clipboard2'
import globals from './globals'
import Popper from 'popper.js'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import messages from './mixins/messages'
import Toasted from 'vue-toasted'

Vue.use(Toasted)
Vue.use(VueClipboard)

flatpickr.localize(Turkish)

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(ToastPlugin)

// Global RTL flag
Vue.mixin({
  data: globals
})
Vue.mixin(messages)

if (globals().akaidOkuluMu) {
  router.addRoutes([{
    path: '/kayit',
    name: 'Kayit',
    component: () => import('@/views/auth/kayitAkaidOkulu')
  }, {
    path: '/bayan-kayit',
    name: 'Bayan-Kayit',
    component: () => import('@/views/auth/kayitAkaidOkulu')
  },
  {
    path: '/bayankayit',
    name: 'BayanKayit',
    component: () => import('@/views/auth/kayitAkaidOkulu')
  }])
} else if (globals().uluedMi) {
  router.addRoutes([{
    path: '/kayit',
    name: 'Kayit',
    component: () => import('@/views/auth/uluedkayit')
  }, {
    path: '/bayan-kayit',
    name: 'Bayan-Kayit',
    component: () => import('@/views/auth/uluedkayit')
  },
  {
    path: '/bayankayit',
    name: 'BayanKayit',
    component: () => import('@/views/auth/uluedkayit')
  }, {
    path: '/ogrenci-kayit',
    name: 'UluedKayit',
    component: () => import('@/views/auth/uluedkayit')
  }, {
    path: '/bayan-ogrenci-kayit',
    name: 'UluedBayanOgrenciKayit',
    component: () => import('@/views/auth/uluedkayit')
  }])
} else {
  router.addRoutes([{
    path: '/kayit',
    name: 'Kayit',
    component: () => import('@/views/auth/kayit')
  }, {
    path: '/bayan-kayit',
    name: 'Bayan-Kayit',
    component: () => import('@/views/auth/kayit')
  },
  {
    path: '/bayankayit',
    name: 'BayanKayit',
    component: () => import('@/views/auth/kayit')
  }])
}

window.lokum = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
